import { createReducer, combineReducers } from 'store/createReducer';
import { IHeaderCompareModel } from 'models/IHeaderCompareModel';
import {
  COMPARE_GET_LIST,
  COMPARE_ITEM_ADD,
  COMPARE_LIST_TOGGLE,
  COMPARE_ITEM_REMOVE,
  CompareListAction,
  CompareRequestAction,
  COMPARE_CATALOG_REMOVE
} from './actions';
import { ICompareItem } from 'models/ICompareItem';

type CompareModel = ICompareItem[];

const compareReducer = {
  [COMPARE_ITEM_ADD]: (
    state: CompareModel,
    { webCatalog, productId, categoryName }: CompareRequestAction
  ) => {
    const exists = state.find(item => item.webCatalog === webCatalog);

    if (exists) {
      return state.map(item =>
        item.webCatalog === webCatalog ? { ...item, products: [...item.products, productId] } : item
      );
    }

    return [...state, { webCatalog, categoryName, products: [productId] }];
  },
  [COMPARE_ITEM_REMOVE]: (state: CompareModel, action: CompareRequestAction) => {
    return state.map(item =>
      item.webCatalog === action.webCatalog
        ? { ...item, products: item.products.filter(product => product !== action.productId) }
        : item
    );
  },
  [COMPARE_GET_LIST]: (_: CompareModel, { list }: CompareListAction) => {
    return list;
  },
  [COMPARE_CATALOG_REMOVE]: (state: CompareModel, action: CompareRequestAction) => {
    return state.filter(c => c.webCatalog !== action.webCatalog);
  }
};

export const initialHeaderCompareState: IHeaderCompareModel = {
  categories: [],
  isOpen: false
};
const isOpen = createReducer(initialHeaderCompareState.isOpen, {
  [COMPARE_LIST_TOGGLE]: (state: boolean) => {
    return !state;
  }
});

export const initialState: CompareModel = [];
export const compare = createReducer(initialState, compareReducer);
export const headerCompare = combineReducers({
  categories: compare,
  isOpen
});
